import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 取鄉鎮市
 */
const GetArea = [
    'POST',
    RouteUrlList.API_GetArea.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: '',

        data: [
            {
                zipcode: '100',
                area: '中正區'
            },
            {
                zipcode: '103',
                area: '大同區'
            },
            {
                zipcode: '104',
                area: '中山區'
            },
            {
                zipcode: '105',
                area: '松山區'
            },
            {
                zipcode: '106',
                area: '大安區'
            },
            {
                zipcode: '108',
                area: '萬華區'
            },
            {
                zipcode: '110',
                area: '信義區'
            },
            {
                zipcode: '111',
                area: '士林區'
            },
            {
                zipcode: '112',
                area: '北投區'
            },
            {
                zipcode: '114',
                area: '內湖區'
            },
            {
                zipcode: '115',
                area: '南港區'
            },
            {
                zipcode: '116',
                area: '文山區'
            },
            {
                zipcode: '200',
                area: '仁愛區'
            },
            {
                zipcode: '201',
                area: '信義區'
            },
            {
                zipcode: '202',
                area: '中山區'
            },
            {
                zipcode: '203',
                area: '安樂區'
            },
            {
                zipcode: '204',
                area: '暖暖區'
            },
            {
                zipcode: '205',
                area: '七堵區'
            }
        ]
    }
];
export default GetArea;
